import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import {alertService} from '../../../services';
import {postRestaurantProductOptions, fetchRestaurantProductOptionById, patchRestaurantProductOptions} from '../../../api/restaurantApi'
import { withAsync } from '../../../api/helpers'

export default function AddEdit({ history, match }) {
    const { id } = match.params;
    const isAddMode = !id;
    
    // form validation rules 
    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required('Name is required'),
        price: Yup.number()
            .required('Price is required'),
    });

    // functions to build form returned by useForm() hook
    const { register, handleSubmit, reset, setValue, getValues, errors, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    function onSubmit(data) {
        
        const payload = {
            restaurant: 2, //TODO fetch user data
            name : data.name,
            price : data.price,
            //products : data.products,
        }

        console.log('===>PAYLOAD', payload)

        return isAddMode
            ? createProductOption(payload)
            : updateProductOption(id, payload);
    }

    async function createProductOption(data) {
        console.log('===> THIS IS DATA', data)
        const {error, response } = await withAsync(postRestaurantProductOptions, data)
        console.log('Create product option', response, error)
        if (error) {
            alertService.error(error)
            return
        }
        alertService.success('Product Option added', { keepAfterRouteChange: true });
        history.push('.');
    }

    function updateProductOption(id, data) {
        console.log('WE RUNNING updateProduct', updateProductOption)
        const {error, response } = withAsync(patchRestaurantProductOptions, id, data)
        if (error) {
            alertService.error(error)
            return
        }
        alertService.success('Product Option updated', { keepAfterRouteChange: true });
        history.push('..');
    }

    const [productOption, setProductOption] = useState({});
    
    async function fetchProductOption(id) {
        if (!isAddMode) {
            const {error, response } = await withAsync(fetchRestaurantProductOptionById, id)
            //console.log('Fetch categories response', response, error)
            if (error) {
                console.log('error', error)
                return
            }
            console.log('===>  FETCHCAT RESPONSE', response)
            const fields = ['name', 'price', 'products'];
            fields.forEach(field => setValue(field, response.data[field]));
            setProductOption(response.data)
        }
    }

    useEffect(() => {
        fetchProductOption(id)
    },[]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} onReset={reset}>
            <h1>{isAddMode ? 'Add Product Option' : 'Edit Product Option'}</h1>
            <div className="form-row">
                <div className="form-group col-6">
                    <label>Name</label>
                    <input name="name" type="text" ref={register} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.name?.message}</div>
                </div>
                <div className="form-group col-6">
                    <label>Price (€)</label>
                    <input name="price" type="text" ref={register} className={`form-control ${errors.price ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.price?.message}</div>
                </div>
            </div>
            <div className="form-row">
            <div className="form-group col-12">
                <label>Products</label>
                    <input name="products" type="text" ref={register} className={`form-control ${errors.name ? 'is-invalid' : ''}`} />
                    <div className="invalid-feedback">{errors.products?.message}</div>
                </div>
            </div>
            <div className="form-row">
            <div className="form-group">
                <button type="submit" disabled={formState.isSubmitting} className="btn btn-primary">
                    {formState.isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Save
                </button>
                <Link to={isAddMode ? '.' : '..'} className="btn btn-link">Cancel</Link>
            </div>
        </div>
        </form>
    )
}